<template>
  <div>
    <GmapMap
      id="google-map"
      :center="{ lat: mapData.Latitude, lng: mapData.Longitude }"
      :zoom="10"
      map-type-id="terrain"
      style="width: 100%; height: 400px;"
    >
    </GmapMap>
  </div>
</template>

<script>

export default {
  name: "DashboardMap",
  data() {
    return {
      hoveredMarker: null,
      mapStyles: [
        {
          elementType: "geometry",
          stylers: [
            {
              color: "#242f3e",
            },
          ],
        },
        {
          elementType: "labels.text.fill",
          stylers: [
            {
              color: "#746855",
            },
          ],
        },
        {
          elementType: "labels.text.stroke",
          stylers: [
            {
              color: "#242f3e",
            },
          ],
        },
        {
          featureType: "administrative.locality",
          elementType: "labels.text.fill",
          stylers: [
            {
              color: "#d59563",
            },
          ],
        },
        {
          featureType: "poi",
          elementType: "labels.text.fill",
          stylers: [
            {
              color: "#d59563",
            },
          ],
        },
        {
          featureType: "poi.business",
          stylers: [
            {
              visibility: "off",
            },
          ],
        },
        {
          featureType: "poi.park",
          elementType: "geometry",
          stylers: [
            {
              color: "#263c3f",
            },
          ],
        },
        {
          featureType: "poi.park",
          elementType: "labels.text",
          stylers: [
            {
              visibility: "off",
            },
          ],
        },
        {
          featureType: "poi.park",
          elementType: "labels.text.fill",
          stylers: [
            {
              color: "#6b9a76",
            },
          ],
        },
        {
          featureType: "road",
          elementType: "geometry",
          stylers: [
            {
              color: "#38414e",
            },
          ],
        },
        {
          featureType: "road",
          elementType: "geometry.stroke",
          stylers: [
            {
              color: "#212a37",
            },
          ],
        },
        {
          featureType: "road",
          elementType: "labels.text.fill",
          stylers: [
            {
              color: "#9ca5b3",
            },
          ],
        },
        {
          featureType: "road.highway",
          elementType: "geometry",
          stylers: [
            {
              color: "#746855",
            },
          ],
        },
        {
          featureType: "road.highway",
          elementType: "geometry.stroke",
          stylers: [
            {
              color: "#1f2835",
            },
          ],
        },
        {
          featureType: "road.highway",
          elementType: "labels.text.fill",
          stylers: [
            {
              color: "#f3d19c",
            },
          ],
        },
        {
          featureType: "transit",
          elementType: "geometry",
          stylers: [
            {
              color: "#2f3948",
            },
          ],
        },
        {
          featureType: "transit.station",
          elementType: "labels.text.fill",
          stylers: [
            {
              color: "#d59563",
            },
          ],
        },
        {
          featureType: "water",
          elementType: "geometry",
          stylers: [
            {
              color: "#17263c",
            },
          ],
        },
        {
          featureType: "water",
          elementType: "labels.text.fill",
          stylers: [
            {
              color: "#515c6d",
            },
          ],
        },
        {
          featureType: "water",
          elementType: "labels.text.stroke",
          stylers: [
            {
              color: "#17263c",
            },
          ],
        },
      ],
    };
  },
  props: {
    mapData:Object,
  },
  methods: {
    markerInfo: function (index = null) {
      this.hoveredMarker = index;
    },
  },
  mounted: function () {
    this.$gmapApiPromiseLazy();
  },
};
</script>
<style lang="scss" scoped>
::-webkit-scrollbar {
  display: none;
  width: 5px;
  height: 10px;
}

::-webkit-scrollbar-thumb {
  background-color: rgba(68, 68, 68, 0.26);
}

.siteAlerts:hover::-webkit-scrollbar {
  display: block;
}

.siteLink {
  margin-bottom: 3px;

  a {
    color: #3c8dbc;
    font-size: 16px;
    font-weight: 500;
  }
}

.siteAlert {
  margin: 5px 5px;
  font-size: 14px;
}

.statusIcon {
  width: 10px;
  height: 12px;
  float: left;
  margin-right: 5px;
  margin-top: 2px;
}

.alertText {
  margin-left: 5px;
  margin-top: 3px;
  font-size: 12px;
  color: #b0b0b0;
}

.f2655e {
  background-color: #f2655e;
}

.B8B8B8 {
  background-color: #b8b8b8;
}

.fcff7a {
  background-color: #fcff7a;
}

#google-map::v-deep {
  .siteAlerts {
    margin-right: 15px;
    max-height: 300px !important;
    overflow-y: scroll;
    overflow-x: hidden;
  }

  .siteAlerts:hover {
    padding-right: 10px;
    margin-right: 0px;
  }
}
</style>